import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/hooks/useAuth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "./hooks/useLogin";
import { useIsMobile } from "@/hooks/useIsMobile";
import { MobileAppDownloadPrompt } from "@/components/modals/MobileAppDownloadPrompt";

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { email, isValidEmail, onChange, onKeyDown, onLogin, loading, error } = useLogin();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="bg-muted flex min-h-full flex-col items-center justify-center gap-6 p-6 md:p-10">
      <MobileAppDownloadPrompt open={isMobile} />
      <div className="flex w-full max-w-md flex-col gap-6">
        <a href="#" className="flex items-center gap-2 self-center font-medium">
          <img src="/logo-black.svg" alt="Rebuild" className="h-8" />
        </a>
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Welcome to Rebuild</CardTitle>
            <CardDescription>
              Enter your email below to receive a login code
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                onLogin();
              }}
            >
              <div className="grid gap-6">
                <div className="grid gap-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    required
                  />
                  {error && (
                    <p className="text-sm text-destructive">{error}</p>
                  )}
                </div>
                <Button
                  type="submit"
                  className="w-full"
                  disabled={!isValidEmail || loading}
                >
                  {loading ? "Sending..." : "Send login code"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
        <div className="text-balance text-center text-xs text-muted-foreground">
          We'll send you a one-time passcode to sign in.
        </div>
      </div>
    </div>
  );
};

export default Login;
